"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.leaveVerticalConfigAvailable = exports.initFeatureFlags = exports.initCache = exports.restartSession = void 0;
const initializer_1 = require("../../initializer");
const web_ui_features_1 = require("@gruposantander/web-ui-features");
const config_1 = require("./config");
const restartSession = (sessionData) => {
    initializer_1.Session.finishSession();
    initializer_1.Session.initSession(sessionData);
};
exports.restartSession = restartSession;
const initCache = (cacheData) => {
    cacheData && initializer_1.GlobalCache?.setInitialData(cacheData, config_1.CACHE_LIFETIME);
};
exports.initCache = initCache;
const normalizeFeatureFlags = (featureFlags) => new Map(Array.from(featureFlags, ([key, value]) => [key.toLowerCase(), value]));
const initFeatureFlags = (featureFlags) => {
    const normalizedFeatureFlags = normalizeFeatureFlags(featureFlags);
    (0, web_ui_features_1.setFeatureFlag)(normalizedFeatureFlags);
};
exports.initFeatureFlags = initFeatureFlags;
// TODO: this is the same as leaveVerticalConfigAvailable from DynamicLoadManualStatic
const leaveVerticalConfigAvailable = (id, config) => {
    window.globals = window.globals || {};
    window.globals[id] = config;
    window.globalPromises?.[id]?.();
};
exports.leaveVerticalConfigAvailable = leaveVerticalConfigAvailable;
//# sourceMappingURL=utils.js.map